/**
 * TranscriptSlot — RESERVED SEAM for a future live-transcript + AI answer-fill
 * panel. Renders nothing today.
 *
 * This is the ONLY place that future panel will mount. CallWorkspace already
 * provides callSid/studyId/startedAt and an `onSuggestAnswer` callback that
 * writes a suggested prescreen answer through the SAME optimistic save path as
 * manual entry (PrescreenAllPane's `setAnswerByKey`, backed by
 * usePrescreenAttempt). Building the real panel later therefore needs NO change
 * to CallWorkspace — drop the implementation in here and wire the audio/STT/AI
 * behind this boundary.
 *
 * NOTE: SoftphoneContext does not yet expose the LIVE CallSid during a call
 * (only after, via lastCall.callSid) — exposing it is a one-line addition there
 * when this feature ships, hence `callSid` is typed nullable.
 */
export interface TranscriptSlotProps {
  contactId: string;
  callSid: string | null;
  studyId: string | null;
  startedAt: number | null;
  /** A future panel pushes an AI-suggested answer into the live prescreen. */
  onSuggestAnswer?: (
    questionKey: string,
    value: unknown,
    meta: { confidence: number; sourceSpanMs?: [number, number] }
  ) => void;
}

export default function TranscriptSlot(_props: TranscriptSlotProps) {
  // Intentionally empty until the live-transcript feature ships.
  return null;
}
